import { useMerchant } from '../contexts/MerchantContext'
import { useUser } from '../contexts/UserContext'
import { putRequest } from '../core/api-client'
import { apiURI } from '../utils/constants'

export enum ChurnSwitchEventsName {
  CHURN_SWITCH = 'churn_switch',
  DISABLE_IMMEDIATELY_CLICKED = 'disable_immediately_clicked',
  DISABLE_CONTINUE_CLICKED = 'disable_continue_clicked',
  DISABLE_CONFIRM_CLICKED = 'disable_confirm_clicked',
  CALENDLY_BOOKED = 'calendly_booked',
  CHURN_REASON_SELECTED = 'churn_reason_selected'
}

type ChurnReasonEvents = {
  merchant_id: string
  timestamp: number
  action_name?: ChurnSwitchEventsName
  event_type: string
  store_user_id: string
  user_email: string
  user_name?: string
  designation?: string
  roles: string[]
  is_super_admin: boolean
  metadata?: {
    switch_state?: string
    churn_reason?: string
    churn_reason_text?: string
    calendly_details?: {
      booking_url: string
      start_time: string
      end_time: string
    }
  }
}

export const useChurnSwitchEvents = () => {
  const {
    getters: { merchant }
  } = useMerchant()
  const { user } = useUser()

  const sendChurnSwitchBody: ChurnReasonEvents = {
    merchant_id: merchant?.accountId ?? '',
    timestamp: new Date().getTime(),
    event_type: 'churn_events',
    store_user_id: user?.id ?? '',
    user_email: user?.email ?? '',
    user_name: `${user?.firstName} ${user?.lastName}` || user?.email,
    designation: user?.role,
    roles: user?.roles ?? [],
    is_super_admin: user?.isSuperAdmin ?? false
  }
  const generateActivityLogBody = (payload: Partial<ChurnReasonEvents['metadata']>, actionName: string) => {
    return {
      ...sendChurnSwitchBody,
      action_name: actionName,
      metadata: {
        ...sendChurnSwitchBody.metadata,
        ...payload
      }
    }
  }

  const sendChurnSwitchEvents = async (payload: Partial<ChurnReasonEvents['metadata']>, actionName: string) => {
    const body = generateActivityLogBody(payload, actionName)
    const url = `${apiURI.ACTIVITY_LOG_SEND}/pulse`
    try {
      navigator.sendBeacon(url, JSON.stringify(body))
    } catch (err) {
      console.error(err)
    }
  }

  return {
    sendChurnSwitchEvents
  }
}
